import { TFunction } from 'i18next';

import { formatHoursToTimeString, minutesToHours } from '@/helpers';
import { PART_OF_DAY_LABEL_KEY } from '@/modules/time-off/constants/time-off-part-of-day-labels';
import { DayPortion, TimeOffRequestDay } from '@/modules/time-off/types/time-off-request';

/**
 * Human label for a single time-off day. HOURLY portions (which arrive with
 * `partOfDay: CUSTOM`) read as e.g. "Hourly: 1h" using the day's `minutes`;
 * every other portion uses the standard part-of-day label ("Full day",
 * "1st quarter", …).
 *
 * @param t - a `TFunction` bound to (or able to resolve) the
 *   `authenticated.timeOff` and `authenticated.timeTracking` namespaces.
 */
export const getTimeOffDayLabel = (day: TimeOffRequestDay, t: TFunction): string => {
  if (day.portion === DayPortion.Hourly) {
    const hours = formatHoursToTimeString(minutesToHours(day.minutes ?? 0));
    return t('authenticated.timeTracking:timeOff.hourlyLabel', { hours });
  }
  return t(`authenticated.timeOff:${PART_OF_DAY_LABEL_KEY[day.partOfDay]}`);
};
